// @ts-nocheck
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useFetch from "../../../ApiClient/GetApi";
import { PostApi } from "../../../ApiClient/PostApi";
import { Loader2 } from "../../loader/Loader";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import Header from "../layout/Header";
import { BulletList, Facebook } from "react-content-loader";
import { useNavigate } from "react-router-dom";
export default function PaymentDetails() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  const closeModal = () => {
    setModal(false);
  };
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");

  const { data } = useFetch(
    `booking/payment_detail_page/${localStorage.getItem("orderId")}`
  );

  const [loading, SetLoading] = useState(false);

  const paystack_payment = async () => {
    SetLoading(true);
    const res = await PostApi("users/home/paystack_payment", {
      amount:
        data?.data?.serviceType === "Full Services"
          ? Number(data?.data?.freightPrice) + Number(data?.data?.insurance)
          : data?.data?.totalPrice,
      booking_id: localStorage.getItem("orderId"),
    });
    if (res.data.status === true) {
      SetLoading(false);
      localStorage.setItem("transactionId", res.data.data.reference);
      window.location.href = res.data.data.authorization_url;
    } else {
      error_toaster("Something went wrong!");
      SetLoading(false);
    }

    //
  };

  const paypal_payment = async () => {
    SetLoading(true);
    const res = await PostApi("users/home/paypal_payment", {
      amount:
        data?.data?.serviceType === "Full Services"
          ? data?.data?.freightPrice
          : data?.data?.totalPrice,
    });

    if (res.data.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      res.data.data.links.map((link) => {
        if (link.rel === "approval_url") {
          localStorage.setItem("transactionId", res.data.data.id);
          window.location.href = link.href;
        }
      });
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };

  const payment_options = () => {
    navigate("/paypal_options");
  };

  return (
    <section className="font-soehne">
      <Header />
      <Modal
        isOpen={modal}
        onClose={closeModal}
        size={`${xl ? "3xl" : md ? "2xl" : sm ? "xl" : xs ? "sm" : "xs"}`}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <div
              className="inline border-2 border-black border-opacity-60 px-1.5 float-right 
                rounded-fullest cursor-pointer sm:text-black"
              onClick={closeModal}
            >
              <FontAwesomeIcon
                icon={faMultiply}
                className="text-black text-opacity-60"
              />
            </div>
            <div className="flex flex-col items-center justify-center gap-y-5 py-10">
              <div
                className="text-themeRed border-4 border-themeRed sm:min-w-[80px] min-w-[60px] 
                    sm:min-h-[80px] min-h-[60px] rounded-fullest inline-flex justify-center items-center"
              >
                <FaCheck size={sm ? 48 : 36} />
              </div>
              <h3 className="font-bold text-2xl text-themeBlue text-center">
                Thank you!
              </h3>
              <p className="font-normal text-base text-black text-opacity-60 text-center leading-4">
                Your order has been confirmed. You can track{" "}
                <br className="sm:block hidden" /> your order in real time
              </p>
              <div>
                <button
                  onClick={closeModal}
                  className="font-bold sm:text-xl text-base text-white bg-themeBlue py-3 px-8 rounded-md
                    border border-themeBlue hover:text-themeBlue hover:bg-transparent"
                >
                  That's Great
                </button>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
      <section
        className="xl:w-4/5 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-12 py-8 sm:px-8 px-4 
            rounded-lg"
      >
        {data.length === 0 ? (
          <Loader2 />
        ) : (
          <>
            {loading ? (
              <Facebook height={160} />
            ) : (
              <div className="grid lg:grid-cols-12 gap-x-10 gap-y-12">
                <div className="lg:col-span-7 space-y-8">
                  <div className="flex items-center gap-x-3">
                    <img
                      src="images/myOrders/card.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Payment Details
                    </h1>
                  </div>
                  <div className="flex sm:flex-row flex-col sm:items-center gap-x-6 gap-y-4">
                    <button
                      onClick={paystack_payment}
                      className="flex items-center gap-x-3 bg-white font-normal text-base px-8 py-5 
                      rounded-xl"
                    >
                      <img
                        src="images/myOrders/paystack.webp"
                        alt="paystack"
                        className="w-8"
                      />
                      <span>Pay with Paystack</span>
                    </button>
                    <button
                      onClick={payment_options}
                      className="flex items-center gap-x-3 bg-white font-normal text-base px-8 py-5 
                rounded-xl"
                    >
                      <img
                        src="images/myOrders/paypal.webp"
                        alt="paypal"
                        className="w-8"
                      />
                      <span>Pay with PayPal</span>
                    </button>
                  </div>
                  <div>
                    {/* <div className="grid sm:grid-cols-2 gap-x-7 gap-y-4">
                  <input
                    type="number"
                    name="cardNo"
                    placeholder="XXXX XXXX XXXX XXXX"
                    className={`${inputStyle} sm:col-span-2`}
                  />
                  <input
                    type="number"
                    name="expiry"
                    placeholder="Expiry"
                    className={inputStyle}
                  />
                  <input
                    type="number"
                    name="cvv"
                    placeholder="CVV"
                    className={inputStyle}
                  />
                </div> */}
                  </div>
                </div>
                <div className="lg:col-span-5 sm:space-y-6 space-y-4">
                  <div className="flex lg:justify-center items-center gap-x-3">
                    <img
                      src="images/myOrders/invoice.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Invoice Details
                    </h1>
                  </div>
                  <ul className="space-y-6">
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Insurance
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.insurance}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Freight ( kg * {data?.data?.companyTax})
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.freighPrice}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Repacking Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.repacking}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import VAT
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.vatTax ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import Duties
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.importDuty ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Customs Clearance Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.customerClearanceFee ?? ""}
                      </h5>
                    </li>
                  </ul>

                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    Total Price : $ {data?.data?.totalPrice ?? ""}
                  </h1>
                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    {data?.data?.serviceType === "Full Services" ? (
                      <div>
                        {" "}
                        <span className="text-sm font-normal mx-4">
                          For Full Services only to pay( Freight + Insurance)
                        </span>
                        <br />$ {data?.data?.freightPrice}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </h1>

                  {/* <div className="flex justify-end">
              <button
                onClick={openModal}
                className="font-bold sm:text-xl text-base text-white bg-themeBlue px-6 py-3 rounded-md
                border border-themeBlue hover:bg-transparent hover:text-themeBlue"
              >
                Secure Pay
              </button>
            </div> */}
                </div>
              </div>
            )}
          </>
        )}
      </section>
    </section>
  );
}
